import React, { useCallback, useEffect, useState } from 'react';
import { Flex, VerticalSpacing } from '@banhala/ui-kit';
import type { InquiryTabProps } from './types/InquiryTabProps';
import { ContentContainer } from '../ContentContainer';
import { InquiryGoodsSkuCode, InquiryGoodsQuestion } from './components';
import { useGoodsSno } from '../../../../hooks/useGoodsSno';
import { isWeb, useNavigator } from 'shared/src/utils';
import { useLogGoodsAnalyticsEvent } from '../../../../hooks/useLogGoodsAnalyticsEvent';
import { useAppDownloadModal } from 'shared/src/hooks';

export const InquiryTab: React.FC<InquiryTabProps> = ({
  focused,
  onChangeTabHeight,
}) => {
  const goodsSno = useGoodsSno();
  const logGoodsDetail = useLogGoodsAnalyticsEvent();
  const [height, setHeight] = useState(0);
  const [savedHeight, setSavedHeight] = useState(0);
  const { navigator } = useNavigator();
  const { show: openModal } = useAppDownloadModal();

  useEffect(() => {
    if (height !== 0 && savedHeight !== height) {
      setSavedHeight(height);
      onChangeTabHeight(height);
    }
  }, [height, onChangeTabHeight, savedHeight]);

  const handleClickNotice = useCallback(() => {
    navigator.moveToWebview(`/goods/${goodsSno}/guide`);
  }, [goodsSno, navigator]);

  const handleClickInquiry = useCallback(() => {
    logGoodsDetail({
      name: 'CLICK_WRITE_GOODS_INQUIRY',
    });

    if (isWeb) {
      openModal();
      return;
    }

    navigator.moveToWebview(`/help/inquiry/new?type=GOODS&sno=${goodsSno}`, {
      titleBar: true,
    });
  }, [logGoodsDetail, navigator, goodsSno, openModal]);

  return (
    <ContentContainer focused={focused}>
      <Flex
        onLayout={event => {
          setHeight(event.nativeEvent.layout.height);
        }}
      >
        <InquiryGoodsSkuCode />
        <InquiryGoodsQuestion
          onClickNotice={handleClickNotice}
          onClickInquiry={handleClickInquiry}
        />
        <VerticalSpacing size={64} />
      </Flex>
    </ContentContainer>
  );
};
